<template>
  <div class="mb-5">
    <div class="fv-row">
      <div class="d-flex flex-column">
        <!--begin::Label-->
        <label class="required form-label">{{ label }}</label>
        <!--begin::Switch-->
        <div
          class="form-check form-switch form-switch-lg form-check-custom form-check-solid"
        >
          <label class="form-check-label mx-2">Tidak</label>
          <input
            class="form-check-input"
            type="checkbox"
            :value="modelValue"
            :checked="modelValue"
            @change="updateValue"
          />
          <label class="form-check-label">Ya</label>
        </div>
        <!--end::Switch-->
        <!--end::Label-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: String,
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.checked);
    },
  },
};
</script>
